import React, { useRef, useState, useEffect } from 'react'
import { Select, SelectProps } from 'antd'
import type { SelectValue } from 'antd/es/select'
import styles from './index.less'

export type { SelectValue }

export interface GylSelectProps extends SelectProps<SelectValue> {
    /** 选择框内前缀元素，类似 Input 的 prefix */
    prefix?: React.ReactNode
}

export type { GylSelectProps as SelectProps }

const defaultProps: SelectProps<SelectValue> = {
    showArrow: true,
    allowClear: true,
}

const INITIAL_PREFIX_WIDTH = 0

const GylSelect = ({ prefix, ...restProps }: GylSelectProps) => {
    const prefixRef = useRef<HTMLSpanElement>(null)
    const [prefixWidth, setPrefixWidth] = useState(INITIAL_PREFIX_WIDTH)

    useEffect(() => {
        if (prefixRef.current) {
            setPrefixWidth(prefixRef.current.offsetWidth)
        }
    }, [prefix])

    if (!prefix) {
        return <Select {...defaultProps} {...restProps} />
    }

    return (
        <div
            className={styles.prefixWrapper}
            style={{ '--prefix-width': `${prefixWidth}px` } as React.CSSProperties}
        >
            <span ref={prefixRef} className={styles.prefix}>
                {prefix}
            </span>
            <Select {...defaultProps} {...restProps} />
        </div>
    )
}

GylSelect.Option = Select.Option

export default GylSelect
